import { Attributes, List, LookupBase } from '@singularsystems/neo-core';
import LetterAuthorisationSignatureLookup from './LetterAuthorisationSignatureLookup';

export default class LetterAuthorisationLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public letterAuthorisationId: number = 0;

    @Attributes.Nullable()
    public dividendAccrualId: number | null = null;

    @Attributes.Nullable()
    public investorId: number | null = null;

    @Attributes.Nullable()
    public emailAddress: string | null = null;

    public isLetterPasswordProtected: boolean = false;
    
    @Attributes.Nullable()
    public letterPassword: string | null = null;

    @Attributes.Nullable()
    public readonly investorReferralTypeId: number | null = null;

    public readonly boolFilter: boolean | null = null;

    public refNo: string = "";

    public description: string = "";

    @Attributes.Float()
    public amount: number = 0;

    public recordIsAuthorised: boolean = false;

    @Attributes.Observable()
    public isComplete: boolean = false;

    @Attributes.Date()
    public sentOn: Date | null = null;

    @Attributes.Nullable()
    public readonly fileId: number | null = null;

    @Attributes.Observable()
    public signatures = new List(LetterAuthorisationSignatureLookup);

    // Client only properties / methods

    public get signedBy() {
        return this.signatures.map(c => c.signatoryName).join(", ");
    }

    public get hasFile() {
        return this.fileId != null;
    }
}